import { render } from "./CompensationBenefits.vue?vue&type=template&id=416fbcfe"
import script from "./CompensationBenefits.vue?vue&type=script&lang=js"
export * from "./CompensationBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__